/// <reference path="../_references.ts"/>

module App.DispatchSummary {
	import Technician = App.Administrative.Inventory.Technician;

	export class DispatchSummaryService {

		constructor(public $http: ng.IHttpService, public Constants: IConstants) {}

		public getAllAppointmentStatuses(): ng.IHttpPromise<Status[]> {
			return this.$http.get(this.Constants.apiUrl + 'appointment/status');
		}

		public getAllStatuses(): ng.IHttpPromise<Status[]> {
			return this.$http.get(this.Constants.apiUrl + 'servicerequeststatus');
		}

		public getDispatchSummaryList(day: Date): ng.IHttpPromise<ServiceRequest[]> {
			return this.$http.get(this.Constants.apiUrl + 'servicerequest/summary_list', {
				params: {
					day: moment(day).format('YYYY-MM-DD')
				}
			});
		}

		public getAllDepartments(): ng.IHttpPromise<Department[]> {
			return this.$http.get(this.Constants.apiUrl + 'department');
		}

		public getAllTechnicians(): ng.IHttpPromise<Technician[]>  {
			return this.$http.get(this.Constants.apiUrl + 'technician');
		}

		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) =>
				new DispatchSummaryService($http, Constants);

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}